module.exports = __webpack_public_path__ + "static/img/bg-pic.87ba3c0.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/costumers/Telll/bg-pic.png
// module id = NV63
// module chunks = 0